import { ShopState } from 'types/shop'
import { StripeCardType } from 'types/stripe'

export const FETCH_SHOP = 'FETCH_SHOP'
export const fetchShopAction = (shop: ShopState) => {
  return {
    type: 'FETCH_SHOP',
    payload: shop,
  }
}

export const INIT_SHOP = 'INIT_SHOP'
export const initShopAction = () => {
  return {
    type: 'INIT_SHOP',
    payload: null,
  }
}

export const REGISTER_CARD = 'REGISTER_CARD'
export const registerCardAction = (stripe_customer_id: string, stripe_payment_method_id: string) => {
  return {
    type: 'REGISTER_CARD',
    payload: {
      stripe_customer_id: stripe_customer_id,
      stripe_payment_method_id: stripe_payment_method_id,
    },
  }
}

export const SAVE_SHOP = 'SAVE_SHOP'
export const saveShopAction = (shop: ShopState) => {
  return {
    type: 'SAVE_SHOP',
    payload: shop,
  }
}

export const RETRIEVE_CARD = 'RETRIEVE_CARD'
export const retrieveCardAction = (card: StripeCardType) => {
  return {
    type: 'RETRIEVE_CARD',
    payload: card,
  }
}
